import React, { useRef, useEffect } from 'react'
import PropTypes from 'prop-types'
import { Textarea, Switch, Text, Dropdown } from '../fields'
import { useForm, Controller } from 'react-hook-form';
import './_zone.scss'
import '../fields/_fields.scss'
import { useTranslation } from '../../hooks';

const Zone = ({ title, copy, fields, name, onSubmit, onValidityChange, disabled, submitLabel = 'Submit' }) => {
  const { i18n } = useTranslation();

  const { current: fieldsMap } = useRef({
    textarea: Textarea,
    switch: Switch,
    text: Text,
    dropdown: Dropdown
  })

  const { control, formState: { isValid }, handleSubmit } = useForm({ mode: 'onChange' });

  const renderField = field => {
    const Field = fieldsMap[field.component];

    return (
      <Controller
        control={control}
        key={field.options?.name}
        name={field.options?.name}
        rules={{ required: !!field.validations?.required }}
        defaultValue={field.options?.value}
        render={({
          field: { value, onChange, onBlur },
          fieldState: { error }
        }) => (
          <Field
            onBlur={onBlur}
            onChange={onChange}
            disabled={disabled}
            errorMessage={error?.message}
            {...field.options}
            value={value}
          />
        )}
      />
    )
  }

  const _handleSubmit = (data, e) => {
    e.preventDefault();

    const parsedData = fields.map(f => ({
      ...f,
      options: {
        ...f.options,
        value: data[f.options.name]
      }
    }));

    onSubmit(parsedData);
  }

  useEffect(() => {
    onValidityChange(isValid);
  }, [isValid])

  return (
    <form className="zone" id={name} onSubmit={handleSubmit(_handleSubmit)}>
      {title && <h2 className="zone__title">{i18n(title)}</h2>}
      {copy && <div className="zone__copy html" dangerouslySetInnerHTML={{__html: i18n(copy)}} />}
      {fields.map(renderField)}
    </form>
  )
}


Zone.propTypes = {
  title: PropTypes.string,
  copy: PropTypes.string,
  name: PropTypes.string.isRequired,
  submitLabel: PropTypes.string,
  onSubmit: PropTypes.func.isRequired,
  onValidityChange: PropTypes.func,
  disabled: PropTypes.bool,
  fields: PropTypes.arrayOf(PropTypes.shape({
    type: PropTypes.oneOf(['text', 'input', 'textarea', 'switch', 'dropdown']),
    options: PropTypes.shape({
      name: PropTypes.string,
      placeholder: PropTypes.string,
      text: PropTypes.string,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]),
      label: PropTypes.string,
    }),
    validations: PropTypes.shape({
      required: PropTypes.shape({
        message: PropTypes.string,
      })
    })
  }))
}

export default Zone;
